import React from 'react';

interface LinkIconProps {
	className?: string;
	size?: 'small' | 'medium' | 'large';
}

const LinkIcon = ({ className, size = 'large', ...props }: LinkIconProps) => (
	<svg
		{...props}
		width={size === 'small' ? '16' : size === 'medium' ? '20' : '24'}
		height={size === 'small' ? '16' : size === 'medium' ? '20' : '24'}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className={className}
		style={{
			minWidth: size === 'small' ? '16' : size === 'medium' ? '20' : '24',
			minHeight: size === 'small' ? '16' : size === 'medium' ? '20' : '24',
		}}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M11.3004 4.62636C13.5365 2.4371 17.1183 2.45607 19.3311 4.66888C21.5439 6.88169 21.5629 10.4635 19.3736 12.6996L18.6591 12L19.3662 12.7071L17.7022 14.3711C17.6863 14.3871 17.6698 14.4025 17.6528 14.4173C15.3686 16.4114 11.9625 16.4114 9.67835 14.4173C9.26231 14.0541 9.21949 13.4224 9.58271 13.0063C9.94593 12.5903 10.5776 12.5475 10.9937 12.9107C12.5163 14.24 14.7828 14.2469 16.3132 12.9316L17.948 11.2969C19.3668 9.84389 19.3533 7.51953 17.9169 6.0831C16.4793 4.64549 14.1523 4.63317 12.6996 6.05547C12.3049 6.44184 11.6718 6.43513 11.2854 6.04049C10.8991 5.64586 10.9058 5.01273 11.3004 4.62636ZM6.34719 9.58269C8.63133 7.58854 12.0375 7.58854 14.3216 9.58269C14.7377 9.94591 14.7805 10.5776 14.4173 10.9937C14.0541 11.4097 13.4223 11.4525 13.0063 11.0893C11.4837 9.76003 9.21714 9.75304 7.68673 11.0683L6.05196 12.7032C4.63316 14.1561 4.64663 16.4805 6.08306 17.9169C7.52067 19.3545 9.84766 19.3669 11.3004 17.9446C11.695 17.5582 12.3282 17.5649 12.7145 17.9595C13.1009 18.3542 13.0942 18.9873 12.6996 19.3737C10.4634 21.5629 6.88166 21.544 4.66885 19.3312C2.45604 17.1183 2.43707 13.5366 4.62633 11.3004L5.34089 12L4.63377 11.2929L6.29774 9.6289C6.3137 9.61294 6.33019 9.59753 6.34719 9.58269Z"
			fill="currentColor"
		/>
	</svg>
)

export default LinkIcon
